import { render, staticRenderFns } from "./terms-dialog.vue?vue&type=template&id=cb77157a&scoped=true&"
import script from "./terms-dialog.vue?vue&type=script&lang=js&"
export * from "./terms-dialog.vue?vue&type=script&lang=js&"
import style0 from "./terms-dialog.vue?vue&type=style&index=0&id=cb77157a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb77157a",
  null
  
)

export default component.exports